/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getRecommendedDidCredentials.defs.js'
export * as $defs from './getRecommendedDidCredentials.defs.js'
